// extracted by mini-css-extract-plugin
export var container = "_qb-0";
export var dotAnimation = "_qb-2";
export var dotsLoading = "_qb-1";